import { render, staticRenderFns } from "./AssignmentTabs.vue?vue&type=template&id=015301ae&scoped=true&"
import script from "./AssignmentTabs.vue?vue&type=script&lang=js&"
export * from "./AssignmentTabs.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentTabs.vue?vue&type=style&index=0&id=015301ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015301ae",
  null
  
)

export default component.exports